module.exports = __webpack_public_path__ + "static/media/c.4ffb8d1f.png";